import React from "react";
import * as RadixSwitch from "@radix-ui/react-switch";
import { cn } from "../../lib/cn";

export interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel?: string;
  disabled?: boolean;
  className?: string;
}

/** claudesign 36×20 mini inline toggle (Radix Switch). */
export const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  ariaLabel,
  disabled,
  className,
}) => (
  <RadixSwitch.Root
    checked={checked}
    onCheckedChange={onChange}
    disabled={disabled}
    aria-label={ariaLabel}
    className={cn(
      "relative inline-flex items-center w-[36px] h-[20px] rounded-full shrink-0",
      "bg-[#2b2f36] transition-colors duration-150 cursor-pointer",
      "data-[state=checked]:bg-accent-grad data-[state=checked]:shadow-glow",
      "disabled:cursor-default disabled:opacity-55",
      className,
    )}
  >
    <RadixSwitch.Thumb
      className={cn(
        "block w-[16px] h-[16px] rounded-full bg-[#6b727a]",
        "translate-x-[2px] transition-transform duration-150 will-change-transform",
        "data-[state=checked]:translate-x-[18px] data-[state=checked]:bg-white",
      )}
    />
  </RadixSwitch.Root>
);

export default Switch;
